var utils = require('../../utils')

export default {
  name: 'careman-detail',
  data: function () {
    return {
      careman: null,
      caremanHisId: null,
      utils: utils,
      searchCallbackFlag: false // 検索結果フラグ
    }
  },
  created: function () {
    // システム管理者 または 薬剤師
    this.$store.dispatch('USER_ADMIN_PHARMACIST')

    this.search()
  },
  computed: {
    caremanHistories() {
      return this.$store.getters.caremanHistories
    },
    loading() {
      return this.$store.getters.apiLoading
    },
    /** 管理者 または 組織長かつ薬剤師 */
    isAdminOrPharmacistManager() {
      return this.$store.getters.userAdminOrPharmacistManager
    },
    /** 通知 */
    notify() {
      return this.$store.getters.caremanNotify
    }
  },
  methods: {
    search: function () {
      this.clearCareman()
      var data = {}
      var self = this
      var callback = function(data){
        if (utils.isBlank(data)) {
          // self.searchCallbackFlag = true
          self.goPrev()
          return
        }
        var exists = false
        for (var d of data) {
          if ( d.attributes['current-flag']) {
            self.careman = d
            self.caremanHisId = d.attributes['careman-history-id']
            exists = true
            break
          }
        }
        // 当日日付が見つからない場合先頭
        if (!exists) {
          if (data !== null && data.length > 0) {
            self.careman = data[0]
            self.caremanHisId = data[0].attributes['careman-history-id']
          }
        }
        self.searchCallbackFlag = true
      }
      this.searchCallbackFlag = false
      this.$store.dispatch('CAREMAN_SEARCH_DETAIL', { caremanId: this.$route.params.caremanId, data: data, callback: callback })
    },
    goFacilities: function () {
      this.$router.push({ path: '/facilities', query:{type: this.$router.currentRoute.query.type} })
    },
    goFacilityPersons: function () {
      this.$router.push({ path: '/facility_persons', query:{type: this.$router.currentRoute.query.type} })
    },
    goClinics: function () {
      this.$router.push({ path: '/clinics', query:{type: this.$router.currentRoute.query.type} })
    },
    goDoctors: function () {
      this.$router.push({ path: '/doctors', query:{type: this.$router.currentRoute.query.type} })
    },
    goCareOffices: function () {
      this.$router.push({ path: '/care_offices', query:{type: this.$router.currentRoute.query.type} })
    },
    goPrev: function () {
      if (utils.isBlank(this.$route.params.careOfficeId)) {
        this.$router.push({ path: '/care_managers', query:{type: this.$router.currentRoute.query.type, keep: 'true'} })
      } else {
        // 介護支援事業所指定
        this.$router.push({ path: '/care_managers/list/' + this.$route.params.careOfficeId, query:{type: this.$router.currentRoute.query.type, keep: 'true'} })
      }
    },
    goCaremanEdit: function () {
      if (utils.isBlank(this.$route.params.careOfficeId)) {
        this.$router.push({ path: '/care_managers/' + this.$route.params.caremanId + '/' + this.caremanHisId + '/edit', query:{type: this.$router.currentRoute.query.type}})
      } else {
        // 介護支援事業所指定
        this.$router.push({ path: '/care_managers/' + this.$route.params.caremanId + '/' + this.caremanHisId + '/edit/' + this.$route.params.careOfficeId, query:{type: this.$router.currentRoute.query.type}})
      }
    },
    clearCareman: function () {
      this.careman = null
      this.caremanHisId = null
      this.$store.dispatch('CAREMAN_DETAIL_CLEAR')
    },
    getReferenceDate: function (d) {
      // 当日が含まれている場合
      if (d.attributes['current-flag']){
        return this.$t('history.today')
      }

      var start = this.utils.sereki2Wareki(this.$t, new Date(d.attributes['start-date']))
      var end = new Date(d.attributes['end-date'])
      if (end.getFullYear() === this.$t('history.max_year')) {
        end = this.$t('history.max_display')
      } else {
        end = this.utils.sereki2Wareki(this.$t, end)
      }
      return start + this.$t('history.delimiter') + end
    },
    changeSelectDate: function () {
      for (var care of this.caremanHistories) {
        if (care.attributes['careman-history-id'] === this.caremanHisId) {
          this.careman = care
          return
        }
      }
    },
    deleteHistory: function () {
      var data = {}
      var self = this
      var callback = function () {
        self.search()
      }
      this.$store.dispatch('CAREMAN_DELETE', { historyId: this.caremanHisId, data: data, callback: callback })
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/careman-detail.js